import { useState } from 'react';

export const useRefertoForm = () => {
  const [squadraA, setSquadraA] = useState(null);
  const [squadraB, setSquadraB] = useState(null);
  const [giocatoriSquadraA, setGiocatoriSquadraA] = useState([]);
  const [giocatoriSquadraB, setGiocatoriSquadraB] = useState([]);
  const [refertoData, setRefertoData] = useState({
    squadraA: {
      fairPlay: '',
      mete: {},
      scalpi1: {},
      scalpi2: {},
      scalpi3: {},
      scalpiBuoni: {},
      assist: {},
      vuotiSquadra: {},
      falliSquadra: {},
      meteTotali: {}
    },
    squadraB: {
      fairPlay: '',
      mete: {},
      scalpi1: {},
      scalpi2: {},
      scalpi3: {},
      scalpiBuoni: {},
      assist: {},
      vuotiSquadra: {},
      falliSquadra: {},
      meteTotali: {}
    },
    girone: '',
    campo: '',
    ore: '',
    note: ''
  });

  const resetForm = () => {
    setSquadraA(null);
    setSquadraB(null);
    setGiocatoriSquadraA([]);
    setGiocatoriSquadraB([]);
    setRefertoData({
      squadraA: {
        fairPlay: '',
        mete: {},
        scalpi1: {},
        scalpi2: {},
        scalpi3: {},
        scalpiBuoni: {},
        assist: {},
        vuotiSquadra: {},
        falliSquadra: {},
        meteTotali: {}
      },
      squadraB: {
        fairPlay: '',
        mete: {},
        scalpi1: {},
        scalpi2: {},
        scalpi3: {},
        scalpiBuoni: {},
        assist: {},
        vuotiSquadra: {},
        falliSquadra: {},
        meteTotali: {}
      },
      girone: '',
      campo: '',
      ore: '',
      note: ''
    });
  };

  // Toggle element marking (click-based interface)
  const toggleStatElement = (team, section, playerIdP, column) => {
    setRefertoData(prev => {
      const newSectionData = { ...prev[team][section] };
      
      if (['scalpi1', 'scalpi2', 'scalpi3'].includes(section)) {
        // Special handling for scalpi sections - each section is independent
        const maxColumns = section === 'scalpi3' ? 2 : 3;
        
        // Find the highest selected column in this specific section
        let highestSelectedInSection = 0;
        for (let i = 1; i <= maxColumns; i++) {
          const key = `${playerIdP}_${i}`;
          if (newSectionData[key] === '1') {
            highestSelectedInSection = i;
          }
        }
        
        // If clicking on the last selected element in this section, toggle just that one
        if (column === highestSelectedInSection && newSectionData[`${playerIdP}_${column}`] === '1') {
          newSectionData[`${playerIdP}_${column}`] = '';
        } else {
          // Clear all values in this section only
          for (let i = 1; i <= maxColumns; i++) {
            const key = `${playerIdP}_${i}`;
            newSectionData[key] = '';
          }
          
          // Set all columns from 1 to the clicked column as selected
          for (let i = 1; i <= column; i++) {
            const key = `${playerIdP}_${i}`;
            newSectionData[key] = '1';
          }
        }
      } else {
        // Standard behavior for other sections
        const maxColumns = 8;
        
        // Find the highest selected column for this player
        let highestSelected = 0;
        for (let i = 1; i <= maxColumns; i++) {
          const key = `${playerIdP}_${i}`;
          if (newSectionData[key] === '1') {
            highestSelected = i;
          }
        }
        
        // If clicking on the last selected element, toggle just that one
        if (column === highestSelected && newSectionData[`${playerIdP}_${column}`] === '1') {
          newSectionData[`${playerIdP}_${column}`] = '';
        } else {
          // Clear all values for this player in this section first
          for (let i = 1; i <= maxColumns; i++) {
            const key = `${playerIdP}_${i}`;
            newSectionData[key] = '';
          }
          
          // Set all columns from 1 to the clicked column as selected
          for (let i = 1; i <= column; i++) {
            const key = `${playerIdP}_${i}`;
            newSectionData[key] = '1';
          }
        }
      }
      
      return {
        ...prev,
        [team]: {
          ...prev[team],
          [section]: newSectionData
        }
      };
    });
  };

  // Toggle team stats (vuoti/falli squadra)
  const toggleTeamStat = (team, section, index) => {
    setRefertoData(prev => {
      const newSectionData = { ...prev[team][section] };
      
      // Get the maximum number for this section
      const maxIndex = section === 'vuotiSquadra' ? 25 : 25;
      
      // Find the highest selected index
      let highestSelected = 0;
      for (let i = 1; i <= maxIndex; i++) {
        if (newSectionData[i] === '1') {
          highestSelected = i;
        }
      }
      
      // If clicking on the last selected element, toggle just that one
      if (index === highestSelected && newSectionData[index] === '1') {
        newSectionData[index] = '';
      } else {
        // Clear all values for this section first
        for (let i = 1; i <= maxIndex; i++) {
          newSectionData[i] = '';
        }
        
        // Set all indices from 1 to the clicked index as selected
        for (let i = 1; i <= index; i++) {
          newSectionData[i] = '1';
        }
      }
      
      return {
        ...prev,
        [team]: {
          ...prev[team],
          [section]: newSectionData
        }
      };
    });
  };

  // Handle general field changes
  const handleGeneralInputChange = (field, value) => {
    if (field.includes('.')) {
      const [team, subField] = field.split('.');
      setRefertoData(prev => ({
        ...prev,
        [team]: {
          ...prev[team],
          [subField]: value
        }
      }));
    } else {
      setRefertoData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  // Convert referto data to match format for saving
  const convertToMatchFormat = () => {
    const convertPlayerStats = (teamData, teamPlayers, teamKey) => {
      return teamPlayers.map((player) => {
        // Count marked elements for each stat type
        const mete = Object.keys(teamData.mete)
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.mete[key] === '1')
          .length;

        const pieni = Object.keys(teamData.scalpiBuoni)
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.scalpiBuoni[key] === '1')
          .length;

        // Count vuoti for each group separately using the new structure
        const vuoti1 = Object.keys(teamData.scalpi1 || {})
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.scalpi1[key] === '1')
          .length;

        const vuoti2 = Object.keys(teamData.scalpi2 || {})
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.scalpi2[key] === '1')
          .length;

        const vuoti3 = Object.keys(teamData.scalpi3 || {})
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.scalpi3[key] === '1')
          .length;


        const assist = Object.keys(teamData.assist)
          .filter(key => key.startsWith(`${player.idP}_`) && teamData.assist[key] === '1')
          .length;

        return {
          ...player,
          mete,
          pieni,
          vuoti1,
          vuoti2,
          vuoti3,
          assist
        };
      });
    };

    // Count team fouls
    const falli1 = Object.keys(refertoData.squadraA.falliSquadra)
      .filter(key => refertoData.squadraA.falliSquadra[key] === '1').length;
    
    const falli2 = Object.keys(refertoData.squadraB.falliSquadra)
      .filter(key => refertoData.squadraB.falliSquadra[key] === '1').length;

    const result = {
      giocatoriSquadraA: convertPlayerStats(refertoData.squadraA, giocatoriSquadraA, 'squadraA'),
      giocatoriSquadraB: convertPlayerStats(refertoData.squadraB, giocatoriSquadraB, 'squadraB'),
      falli1,
      falli2,
      // il voto e' l'unico campo di squadra che non si conta dalle caselle segnate: si scrive
      // a mano nel riquadro in testa alla colonna, come sul referto di carta
      fairPlay1: refertoData.squadraA.fairPlay,
      fairPlay2: refertoData.squadraB.fairPlay
    };
    
    return result;
  };

  return {
    // State
    squadraA,
    squadraB,
    giocatoriSquadraA,
    giocatoriSquadraB,
    refertoData,
    
    // Setters
    setSquadraA,
    setSquadraB,
    setGiocatoriSquadraA,
    setGiocatoriSquadraB,
    setRefertoData,
    
    // Actions
    resetForm,
    toggleStatElement,
    toggleTeamStat,
    handleGeneralInputChange,
    convertToMatchFormat
  };
};